import React from 'react';
import { Button } from '@mui/material';
import { connect } from 'react-redux';
import {
  dublinCoords,
  kerryCoords,
  balbrigganCoords,
  moorockCoords,
  pecanSquareCoords,
  pecanSquareTestSiteCoords
} from '../../constants';
import { setCellId } from 'actions/obstacleActions';

/* eslint-disable react/display-name */
const Teleport = React.forwardRef((props, ref) => {
  const onClickTeleportLocation = (location, cellId)=> () => {
    props.doSetCellId && props.doSetCellId(cellId);
    if (ref?.current?.leafletElement) {
      return ref?.current?.leafletElement.panTo(location);
    } else if (ref?.current?.panTo) {
      return ref?.current?.panTo(location);
    }
  };

  return (
    <>
      <Button
        {...props.btnProps}
        onClick={onClickTeleportLocation(balbrigganCoords, 2)}>
        Balbriggan
      </Button>
      <Button
        {...props.btnProps}
        onClick={onClickTeleportLocation(dublinCoords, 1)}>
        Dublin
      </Button>
      <Button
        {...props.btnProps}
        onClick={onClickTeleportLocation(moorockCoords)}>
        Moorock
      </Button>
      <Button
        {...props.btnProps}
        onClick={onClickTeleportLocation(kerryCoords, 5)}>
        Kerry
      </Button>
      <Button
        {...props.btnProps}
        onClick={onClickTeleportLocation(pecanSquareCoords, 8)}>
        Pecan Square
      </Button>
      <Button
        {...props.btnProps}
        onClick={onClickTeleportLocation(pecanSquareTestSiteCoords, 9)}>
        Pecan Square Test Site
      </Button>
    </>
  );
});

export default (Teleport);
